import { RecordFields, Table, recordLabel } from "@/ui";

export type DiffRow = { field: string; label?: string; before: unknown; after: unknown };
export function DiffTable({ label, rows }: { label: string; rows: DiffRow[] }) {
  return <Table label={label} head={<tr><th scope="col">Field</th><th scope="col">− Before</th><th scope="col">+ After</th></tr>}>{rows.map(row => <tr key={row.field}><th scope="row" title={row.field}>{row.label ?? recordLabel(row.field)}</th><td className="admin-diff-before long">− <RecordFields value={row.before} /></td><td className="admin-diff-after long">+ <RecordFields value={row.after} /></td></tr>)}</Table>;
}

export function changesRows(changes: Record<string, unknown> | null): DiffRow[] {
  return Object.entries(changes ?? {}).map(([field, value]) => {
    const pair = value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : null;
    return { field, before: pair && "before" in pair ? pair.before : "Not recorded", after: pair && "after" in pair ? pair.after : value };
  });
}
